import { useLocation } from 'react-router-dom';

export function useMenuActive(basePath) {
  const location = useLocation();
  return location.pathname === basePath || location.pathname.startsWith(basePath + '/');
}
